import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from './index';
import { AuthService } from '../services/AuthService';
import { modalTypeEnum } from '../types/modal';
import { setUserInfo } from './UserSlice';
import { createNpos } from './NposSlice';
import { UserStatus } from '../types/user-access-level';
import { setRefreshTokenForEncryption } from './EncryptionSlice';
import { setLoaderStatus } from './LoaderSlice';

interface AppState {
    hasConnection: boolean,
    modalSigninUp: modalTypeEnum,
    isRegistered: boolean,
    loginStatus: boolean,
    openMenu: boolean,
    isNpos: boolean,
    newStatus: UserStatus,
    mobileStatus: boolean
}

const initialState: AppState = {
    hasConnection: false,
    modalSigninUp: 0,
    isRegistered: false,
    loginStatus: false,
    openMenu: true,
    isNpos: false,

    // new Status Control
    newStatus: UserStatus.none,
    mobileStatus: false
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setHasConnection: (state, action: PayloadAction<boolean>) => {
            state.hasConnection = action.payload;
        },
        setModalSignInUp: (state, action: PayloadAction<modalTypeEnum>) => {
            state.modalSigninUp = action.payload;
        },
        setIsRegistered: (state, action: PayloadAction<boolean>) => {
            state.isRegistered = action.payload;
        },
        setLoginStatus: (state, action: PayloadAction<boolean>) => {
            state.loginStatus = action.payload;
        },
        closeMenu: (state) => {
            state.openMenu = false;
        },
        openMenu: (state) => {
            state.openMenu = true;
        },
        setIsNpos: (state, action: PayloadAction<boolean>) => {
            state.isNpos = action.payload;
        },
        setNewStatus: (state, action: PayloadAction<UserStatus>) => {
            state.newStatus = action.payload;
        },
        setAppMobileStatus: (state, action: PayloadAction<boolean>) => {
            state.mobileStatus = action.payload;
        },

        resetState: () => initialState
    }
});

export const {
    setHasConnection,
    resetState,
    setModalSignInUp,
    setIsRegistered,
    setLoginStatus,
    openMenu,
    closeMenu,
    setIsNpos,
    setNewStatus,
    setAppMobileStatus
} = appSlice.actions;

// mobile status
export const getAppMobileStatus = (state: RootState) => state.app.mobileStatus

export const checkMobileStatus = ():AppThunk => async (dispatch, getState) => {
    dispatch(setAppMobileStatus(/Mobi|Android|iPhone/i.test(navigator.userAgent)));
}

export const setupAppState = (): AppThunk => async (dispatch) => {
    
    // loader global
    dispatch( setLoaderStatus(true));

    await AuthService.getIp();
    // resetando
    dispatch(setRefreshTokenForEncryption(''));
    const isComingFromUrl = window.location.href.includes('invite=');

    if (isComingFromUrl) {
        
        dispatch( wipeLocalStorage() );
        
        localStorage.setItem('isNpos', String(true));
        dispatch( setIsNpos(true));
        dispatch( createNpos(window.location.href))

    } else {
        
        // Verificar Info Local (registrado - nao logado)
        const hasLocalData = await AuthService.checkLoginData();
        dispatch(setIsRegistered(!hasLocalData));
        dispatch( setLoaderStatus(false));
        
        // @Todo remove the comments when API is back online
        /*
        if (hasLocalData) {
            // Nao Logado - Registrado - Nao logado
            dispatch(setNewStatus(UserStatus.timedOut));
            dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
        } else {
            // Nao Logado - Nao registrado
            dispatch(setNewStatus(UserStatus.none));
            dispatch(setModalSignInUp(modalTypeEnum.register));
        }
        */
    }   


};

// RefreshToken
export const refreshAppState = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
    const rt = state.encryption.refreshToken;
    return await AuthService.refreshAppStatus(rt);
}

// login
export const getModalSignInUp = (state: RootState) => state.app.modalSigninUp

// register
export const getIsRegisterStatus = (state: RootState) => state.app.isRegistered
export const getLoginStatus = (state: RootState) => state.app.loginStatus
export const isMenuOpened = (state: RootState) => state.app.openMenu
export const getIsNpos = (state: RootState) => state.app.isNpos

// Check Status
export const checkUserStatus = (): AppThunk => async (dispatch, getState) => {
    const state = getState();

    const localStorageEncrypted = localStorage.getItem('encryptedData');
    const token = state.encryption.refreshToken;

    if (localStorageEncrypted || !token) {
        // @Todo , remove this comments when API is back online
        //dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
    }
}

// wipe
export const wipeLocalStorage = (): AppThunk => (dispatch) => {
    localStorage.clear();
    dispatch(setUserInfo({}));
    dispatch(setRefreshTokenForEncryption(''))
    dispatch(setModalSignInUp(modalTypeEnum.none));
}

// New User Status Control Functions
/// User Control GET
export const getNewStatus = (state: RootState) => state.app.newStatus

/// User Control SET
export const checkUserNewStatus = (): AppThunk => async (dispatch, getState) => {
    
    const state = getState();

    if (state.app.newStatus !== UserStatus.none) {
        const wallet        = localStorage.getItem('wallet');
        const encryptedData = localStorage.getItem('encryptedData');
        if (wallet && encryptedData) dispatch(setNewStatus(UserStatus.timedOut));
    }

}

export default appSlice.reducer;
